<template>
  <div class="search_module">
    <h1 class="title">文件管理</h1>
    <div class="search">
      <!-- <el-input
        class="ipt"
        @keyup.enter.native="handleEnter($event)"
        placeholder="请输入要搜索的课件"
        v-model="inputVal"
        :value="inputVal"
        @blur="getSeachVal"
      >      -->
       <el-input
        class="ipt"
        placeholder="请输入要搜索的课件"
        v-model="inputVal"
        :value="inputVal"
        @input="getSeachVal"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button class="btn" type="primary"
        ><input
          id="fileId"
          class="file"
          type="file"
          accept="MIME_type"
          @change="upload"
          ref="input"
        /><i class="el-icon-upload el-icon--right"></i>上传课件
      </el-button>
    </div>
  </div>
</template>

<script>
// 1.引入动画组件
import { Message } from "element-ui";
export default {
  name: "upload-head",
  data() {
    return {
      inputVal:'',
    };
  },
  //方法集合
  methods: {
    // 回车失去焦点
    // handleEnter(event) {
    //   event.target.blur();
    //   // 回车失去焦点单独写
    //   // 更新操作应该放到失去焦点的事件中，后面调用接口时重新写blur方法
    //   // this.$message.success("修改成功");
    // },
    navClick(idx) {
      let _this = this;
      _this.curIdx = idx;
    },
    getSeachVal(e) {
      console.log('值',this.inputVal)
      this.$emit("seachVal", this.inputVal);
    },
    // 上传处理
    upload() {
      let file = document.getElementById("fileId").files[0];
      console.log("数据：", file);
      //切割字符串
      let fileArr = file.name.split(".");
      //得到后缀
      let suffix = fileArr[fileArr.length - 1];
      //判断的犯法返回结果
      let result = this.matchType(suffix);
      console.log(result);
      if (result == "未知类型") {
        	Message({
					message: '该文件不符合上传类型',
					type: 'warning'})
        return false;
      } else {
        console.log('文件类型',file)
        this.$emit('uploadFile',file)
      }
      this.$refs.input.value = '';
    },
    // 判断文件类型
    matchType(suffixVal) {
      // debugger;
      // 返回结果
      let result_1 = ""; //视频
      let result_2 = ""; //音频
      let result_3 = ""; //PPT
      let result_4 = ""; //Word
      let result_5 = ""; //PDF

      // 类型格式数组
      let videolist = [
        "3gp",
        "asf",
        "avi",
        "dat",
        "dv",
        "flv",
        "f4v",
        "m2t",
        "m3u8",
        "m4v",
        "mj2",
        "mjpeg",
        "mkv",
        "mov",
        "mp4",
        "mpe",
        "mpg",
        "mpeg",
        "mts",
        "ogg",
        "qt",
        "rm",
        "rmvb",
        "swf",
        "ts",
        "vob",
        "wmv",
        "webm",
      ]; //视频类型格式数组
      let audiolist = [
        "aac",
        "ac3",
        "acm",
        "amr",
        "ape",
        "caf",
        "flac",
        "m4a",
        "mp3",
        "ra",
        "wav",
        "wma",
      ]; //音频类型格式数组
      let pptlist = ["ppt", "pptx"]; //PPT类型格式数组
      let wordlist = ["doc", "docx"]; //Word类型格式数组
      let pdflist = ["pdf"]; //PDF类型格式数组

      // 进行视频匹配
      // eslint-disable-next-line no-unused-vars
      result_1 = videolist.some(function (item) {
        return item == suffixVal;
      });

      if (result_1 != "") {
        return "视频";
      }

      // 进行音频匹配
      // eslint-disable-next-line no-unused-vars
      // result_2 = audiolist.some(function (item) {
      //   return item == suffixVal;
      // });
      // if (result_2 != "") {
      //   return "音频";
      // }

      // 进行PPT匹配
      // eslint-disable-next-line no-unused-vars
      result_3 = pptlist.some(function (item) {
        return item == suffixVal;
      });
      if (result_3 != "") {
        return "PPT";
      }

      // 进行Word匹配
      // eslint-disable-next-line no-unused-vars
      result_4 = wordlist.some(function (item) {
        return item == suffixVal;
      });
      if (result_4 != "") {
        return "Word";
      }

      // 进行PDF匹配
      // eslint-disable-next-line no-unused-vars
      result_5 = pdflist.some(function (item) {
        return item == suffixVal;
      });
      if (result_5 != "") {
        return "PDF";
      }
      return "未知类型";
    },
  },
};
</script>

<style lang="less">
.search_module {
  height: 72px;
  border-bottom: 1px solid #ecf1f8;
  padding: 0 30px;
  background: #fff;
  display: flex;
  //direction: row;
  align-items: center;
  justify-content: space-between;

  div {
    height: 100%;
    line-height: 72px;
  }

  .title {
    font-size: 24px;
    font-weight: 500;
    color: #4c495b;
    text-align: left;
  }

  .search {
    width: 60%;
    display: flex;
    align-items: center;

    .ipt {
      padding-right: 24px;

      .el-input__inner {
        font-size: 16px;
        color: #c7c7cd;
        height: 36px;
        line-height: 36px;
        border-radius: 22px;
      }
      /deep/.el-icon-upload{
        margin-left: 0;
      }
    }

    .btn {
      position: relative;

      input[type="file"] {
        z-index: 1;
        width: 100%;
        height: 100%;
        font-size: 50rem;
        opacity: 0;
        cursor: pointer;
        position: absolute;
      }
    }

    .el-button--primary {
      font-size: 16px;
      width: 145px;
      height: 36px;
      line-height: 36px;
      box-sizing: border-box;
      padding: 0;

      // .el-icon-upload {
      //     font-size: 24px;
      //     margin-right: 9px;
      // }
    }
  }
}
</style>